import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OurTeamCard, TeamMember } from '../../../../shared/components/our-team-card/our-team-card';
import { TranslationService } from '../../../../core/services/translation.service';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-about-our-team',
  imports: [CommonModule, OurTeamCard, TranslatePipe],
  templateUrl: './about-our-team.html',
  styleUrl: './about-our-team.scss',
})
export class AboutOurTeam implements OnInit, OnDestroy {
  teamMembers: TeamMember[] = [];
  private subscription = new Subscription();

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.subscription.add(
      this.translationService.translationsLoaded$.subscribe((loaded) => {
        if (loaded) {
          this.loadTeamMembers();
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private loadTeamMembers() {
    const t = this.translationService.t.bind(this.translationService);
    this.teamMembers = [
      {
        id: 1,
        name: t('about.team.members.ahmed.name'),
        role: t('about.team.members.ahmed.role'),
        image: 'https://images.unsplash.com/photo-1737574821698-862e77f044c1?w=400&h=400&fit=crop',
        linkedinUrl: '#',
        twitterUrl: '#',
      },
      {
        id: 2,
        name: t('about.team.members.sara.name'),
        role: t('about.team.members.sara.role'),
        image: 'https://images.unsplash.com/photo-1610631066894-62452ccb927c?w=400&h=400&fit=crop',
        linkedinUrl: '#',
        twitterUrl: '#',
      },
      {
        id: 3,
        name: t('about.team.members.mohamed.name'),
        role: t('about.team.members.mohamed.role'),
        image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        linkedinUrl: '#',
        twitterUrl: '#',
      },
      {
        id: 4,
        name: t('about.team.members.nourhan.name'),
        role: t('about.team.members.nourhan.role'),
        image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
        linkedinUrl: '#',
        twitterUrl: '#',
      },
    ];
  }
}
